import axios from 'axios';
import { BatchPackageConflictCode } from 'types/batchReturnProcessing';

/** The backend's { error, code } or { message } for a refused action, when there is one. */
export type ApiActionError = { message: string; code?: BatchPackageConflictCode };

export const toApiActionError = (error: unknown, fallback: string): ApiActionError => {
    if (axios.isAxiosError(error) && error.response?.data) {
        const data = error.response.data as { error?: unknown; message?: unknown; code?: BatchPackageConflictCode };
        // ApiError bodies carry error: true beside the message, and a server error's says only "Internal error".
        const refusal =
            error.response.status < 500
                ? [data.error, data.message].find((m): m is string => typeof m === 'string')
                : undefined;
        return { message: refusal ?? fallback, code: data.code };
    }
    return { message: fallback };
};
